import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/images/privilege.png';
const _hoisted_1 = {
  class: "content-center"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "20px 0"
  }
}, " 抱歉，你没有系统的访问权限 ！ ", -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}